// import React from "react";
// import Profile from "../../assets/others/avatar.jpeg";
// import { useMakeRequest } from "../../hooks/useMakeRequest";
// import { USER_URL } from "../../constant/resource";
// import { useAppSelector } from "../../redux/ReduxType";

// const FriendRequest = (
//   requests: any,
//   //   close: () => void,
//   refetch: any
//   //   userId: string
// ) => {
//   const makeRequest = useMakeRequest();
//   const user = useAppSelector((state) => state.user);

//   const acceptReq = (requestId: string) => {
//     const onSuccess = (data: any) => {
//       refetch();
//     };
//     const payload = {
//       userId: user._id,
//       status: "ACCEPTED",
//       requestId: requestId,
//     };
//     makeRequest(
//       USER_URL + `/acceptFriend`,
//       "PUT",
//       payload,
//       onSuccess,
//       console.log,
//       console.log
//     );
//   };
//   const regReq = (requestId: string) => {
//     const onSuccess = (data: any) => {
//       refetch();
//     };
//     const payload = {
//       userId: user._id,
//       status: "DECLINED",
//       requestId: requestId,
//     };
//     makeRequest(
//       USER_URL + `/acceptFriend`,
//       "PUT",
//       payload,
//       onSuccess,
//       console.log,
//       console.log
//     );
//   };
//   return (
//     <div>
//       {requests?.requests?.map((request: any) => {
//         return (
//           <div className={`flex items-center justify-between w-full pt-10`}>
//             <div className="flex items-center justify-center gap-1">
//               <img
//                 className="w-7 h-7 rounded-full border"
//                 src={request?.from?.avatar || Profile}
//                 alt="avatar"
//               />
//               <h1 className="text-black text-sm">{request?.from?.fullname}</h1>
//             </div>
//             <div className="flex items-center justify-center gap-2 text-xs">
//               <button
//                 onClick={() => acceptReq(request._id)}
//                 className="bg-blue-500 text-white p-1 px-2"
//               >
//                 Accept
//               </button>
//               <button
//                 onClick={() => regReq(request._id)}
//                 className="border-2 border-gray-400 text-gray-400 p-1 px-2"
//               >
//                 Reject
//               </button>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default FriendRequest;

// ------- version 2 -------
import React from "react";
import Profile from "../../assets/others/avatar.jpeg";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { USER_URL } from "../../constant/resource";
import { useAppSelector } from "../../redux/ReduxType";
import { toast } from "sonner";

interface FriendRequestProps {
  requests: any;
  refetch: () => void;
}

const FriendRequest: React.FC<FriendRequestProps> = ({ requests, refetch }) => {
  const makeRequest = useMakeRequest();
  const user = useAppSelector((state) => state.user);
  const isDark = useAppSelector((state) => state.theme.isDark);

  console.log("req -->", requests);
  const acceptReq = (requestId: string) => {
    const onSuccess = () => {
      toast.success("Friend request accepted!");
      refetch();
    };
    const onError = (error: any) => {
      toast.error("Error accepting request. Please try again.");
      console.log(error);
    };
    const payload = {
      userId: user._id,
      status: "ACCEPTED",
      requestId: requestId,
    };
    makeRequest(
      USER_URL + `/acceptFriend`,
      "PUT",
      payload,
      onSuccess,
      onError,
      () => {}
    );
  };

  const rejectReq = (requestId: string) => {
    const onSuccess = () => {
      toast.success("Friend request declined.");
      refetch();
    };
    const onError = (error: any) => {
      toast.error("Error declining request. Please try again.");
      console.log(error);
    };
    const payload = {
      userId: user._id,
      status: "DECLINED",
      requestId: requestId,
    };
    makeRequest(
      USER_URL + `/acceptFriend`,
      "PUT",
      payload,
      onSuccess,
      onError,
      () => {}
    );
  };

  return (
    <div className="max-w-2xl mx-auto">
      {requests?.length > 0 ? (
        requests?.map((request: any) => (
          <div
            key={request?._id}
            className={`flex items-center justify-between w-full py-4 px-4 rounded-lg my-2 transition-all duration-200 ${
              isDark
                ? "bg-gray-800 text-gray-200 hover:bg-gray-700"
                : "bg-white text-gray-700 hover:bg-gray-50"
            } shadow-sm hover:shadow-md`}
          >
            <div className="flex items-center gap-3">
              <img
                className="w-10 h-10 rounded-full border-2 border-gray-300 object-cover"
                src={request?.from?.avatar || Profile}
                alt="Avatar"
              />
              <h1 className="text-sm font-medium">
                {request?.from?.fullname || "Unknown User"}
              </h1>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => acceptReq(request._id)}
                className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-colors duration-200 ${
                  isDark
                    ? "bg-blue-600 text-white hover:bg-blue-700"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
              >
                Accept
              </button>
              <button
                onClick={() => rejectReq(request?._id)}
                className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-colors duration-200 ${
                  isDark
                    ? "border-2 border-gray-500 text-gray-400 hover:bg-gray-600 hover:text-white"
                    : "border-2 border-gray-300 text-gray-500 hover:bg-gray-100"
                }`}
              >
                Reject
              </button>
            </div>
          </div>
        ))
      ) : (
        <p
          className={`text-sm text-center py-4 ${
            isDark ? "text-gray-400" : "text-gray-500"
          }`}
        >
          No friend requests at this time.
        </p>
      )}
    </div>
  );
};

export default FriendRequest;
